import React from 'react';
import { DisplayType } from '../../../../../../generated/core-api/graphql-react-query';
import useGlobalStoreContext from '../../../../../Contexts/GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import useDisplay from '../../../../../Contexts/GlobalContext/Hooks/useDisplay';

interface CardCommentNotifyProps {
  defaultProject: string | null;
  currentProjectId: string | null;
  cardId: string;
}
export default function CardCommentNotify(props: CardCommentNotifyProps) {
  const { defaultProject, currentProjectId, cardId } = props;
  const { projectId: [projectId, setProjectId] } = useGlobalStoreContext();
  const display = useDisplay();

  const targetProjectId = currentProjectId ?? defaultProject;

  React.useEffect(() => {
    if (!targetProjectId) return;
    setProjectId(targetProjectId);

    if (projectId === targetProjectId) {
      display(cardId, DisplayType.CardLink);
    }
  }, [cardId, targetProjectId, projectId]);

  return null;
}
